import { __exports as d } from "../../../_virtual/card-number.js";
import { l as g } from "./luhn-10.js";
import { d as m } from "../../credit-card-type/dist/index.js";
Object.defineProperty(d, "__esModule", { value: !0 });
d.cardNumber = void 0;
var y = g, h = m;
function a(l, e, i) {
  return {
    card: l,
    isPotentiallyValid: e,
    isValid: i
  };
}
function c(l, e) {
  e === void 0 && (e = {});
  var i, u, n;
  if (typeof l != "string" && typeof l != "number")
    return a(null, !1, !1);
  var r = String(l).replace(/-|\s/g, "");
  if (!/^\d*$/.test(r))
    return a(null, !1, !1);
  var f = h(r);
  if (f.length === 0)
    return a(null, !1, !1);
  if (f.length !== 1)
    return a(null, !0, !1);
  var t = f[0];
  if (e.maxLength && r.length > e.maxLength)
    return a(t, !1, !1);
  e.skipLuhnValidation === !0 || t.type === h.types.UNIONPAY && e.luhnValidateUnionPay !== !0 ? u = !0 : u = y(r), n = Math.max.apply(null, t.lengths), e.maxLength && (n = Math.min(e.maxLength, n));
  for (var s = 0; s < t.lengths.length; s++)
    if (t.lengths[s] === r.length)
      return i = r.length < n || u, a(t, i, u);
  return a(t, r.length < n, !1);
}
d.cardNumber = c;
export {
  d as default
};
